export default "__VITE_ASSET__dbHsEZpQ__"